import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
  import { LotMapInterface } from "@/types/LotMapInterface";
  import { onMounted, ref } from "vue";
  import { useStore } from "vuex";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EstateMapEmbeddedOptions',
  props: {
    estateId: String,
  },
  emits: ["onMessage"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;
  const store = useStore();
  const loading = ref(true);
  const lotsWithBuilder = ref<LotMapInterface[]>([]);

  const goToEstate = () => {
    const { href } = router.resolve({
      name: "EstateMapV2",
      params: {
        estateId: props.estateId,
      },
    });

    window.open(href, "_blank");
  };

  const goToBuilder = () => {
    const { href } = router.resolve({
      name: "Builder",
      params: {
        estateId: props.estateId,
        lotId: lotsWithBuilder.value[0].lotId._id.toString(),
      },
    });

    window.open(href, "_blank");
  };

  const getLotsList = () => {
    store
      .dispatch("lot/getLotsList", {
        estateId: props.estateId,
        isCustomer: true,
      })
      .then(async (res) => {
        let lots = [];

        res.data.forEach((stage) => {
          lots = [...lots, ...filteredLotData(stage.lotData)];
        });
        lotsWithBuilder.value = lots;
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const filteredLotData = (lotData: LotMapInterface[]) => {
    return lotData.filter(
      (lot: { lotId?: { isBuildersEnabled?: boolean; _id?: string } }) => {
        return lot.lotId?.isBuildersEnabled;
      }
    );
  };

  onMounted(() => {
    getLotsList();
  });

const __returned__ = { props, emits, store, loading, lotsWithBuilder, goToEstate, goToBuilder, getLotsList, filteredLotData, get router() { return router }, get LotMapInterface() { return LotMapInterface }, onMounted, ref, get useStore() { return useStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})